import {SottoILecciView} from "./sotto-i-lecci.view";
export default SottoILecciView;
